// The phone app's stored manual-offline flag (BL-2342, ADR 066 — Offline Mode § 5): its key and its
// synchronous reads. Its own module so the typed client's routing can read it without importing the
// React provider that writes it (BUG-2053).
import { mayBeNativeApp } from '../../gateways/native-device';

/**
 * Where the manual flag lives: the ISO time Go offline was tapped. Per device,
 * not per user, and kept across restarts (ADR 066 — Offline Mode § 5); it is
 * UI state, never server state (rule #16).
 */
export const MANUAL_OFFLINE_STORAGE_KEY = 'auctogon:offline-mode:manual-since';

/**
 * Whether the device was left in manual offline mode, read synchronously so a
 * relaunch starts offline before `OfflineModeProvider`'s async native detection
 * settles: the realtime transport starts suspended, and the typed client's
 * first reads go to the device store (ADR 066 — Offline Mode § 6.2: no socket,
 * catch-up or server read opens in offline mode, including on a relaunch).
 *
 * @returns true when the manual flag is stored; false on the server or with
 *   blocked storage.
 */
export function readManualOfflineFlag(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(MANUAL_OFFLINE_STORAGE_KEY) != null;
  } catch {
    return false;
  }
}

/**
 * Whether this page load starts in manual offline mode, decided before `OfflineModeProvider`
 * reports (it waits for native detection, after the page's first reads): the stored flag, on a
 * page that may be the app. A plain browser never starts offline, whatever a stale flag says, so
 * it never reads the device store (ADR 066 — Offline Mode § 6.1 limit 4). The realtime mount and
 * the typed client's routing both start from this one answer (BUG-2053).
 *
 * @returns true when the flag is stored and the page may be the native app (or its emulation).
 */
export function startsInManualOffline(): boolean {
  return readManualOfflineFlag() && mayBeNativeApp();
}
